import { useQuery } from '@tanstack/react-query';
import { getProjetById } from '../../api/PROJETS/projets';

export const useGetProjetById = (id) => {
  return useQuery({
    queryKey: ['projet', id],
    queryFn: () => getProjetById(id),
    enabled: !!id,
    staleTime: 2 * 60 * 1000,
    retry: false,
  });
};
